import fetch from "auth/FetchInterceptor";

const RoleService = {};
const BASE_URL = "/role";

RoleService.fetchRoles = () =>
    fetch({
        url: BASE_URL,
        method: "get",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
RoleService.postRole = (role) =>
    fetch({
        url: BASE_URL,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: role
    });

RoleService.fetchRole = (id) =>
    fetch({
        url: `${BASE_URL}/${id}`,
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });

RoleService.patchRole = ({ id, role }) =>
    fetch({
        url: `${BASE_URL}/${id}`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
        data: role
    });
export default RoleService;